<div class="m-bulk-count-container">
  <div class="m-bulk-count">
    <ion-row class="m-bulk-count__header">
      <ion-col class="ion-no-padding" size="9">
        <ion-row class="number-stream">
          <ion-col class="ion-no-padding" size="9">
            <ion-row class="number-stream__row">
              <ion-col
                size="4"
                *ngFor="let item of bulkCountStream; let i = index"
                class="ion-no-padding row-item"
                [ngClass]="{ 'row-item--active': i === activeStreamIndex }"
                (click)="updateActiveStreamIndex(i)"
              >
                {{ item }}
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col class="ion-no-padding number-pad-icon" size="3">
            <div (click)="openNumberPad()">
              <ion-img [src]="numPadIcon"></ion-img>
            </div>
          </ion-col>
        </ion-row>
      </ion-col>
      <ion-col class="ion-no-padding arrow-buttons" size="3">
        <ion-row class="ion-align-items-center ion-justify-content-between">
          <ion-col class="ion-no-padding" size="5" (click)="decrementActiveStreamIndex()">
            <ion-img [src]="leftArrowIcon"></ion-img
          ></ion-col>
          <ion-col class="ion-no-padding" size="5" (click)="incrementActiveStreamIndex()">
            <ion-img [src]="rightArrowIcon"></ion-img
          ></ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
    <div class="m-bulk-count__content">
      <ion-row class="bulk-count-info ion-justify-content-around ion-align-items-center">
        <div>
          <div class="bulk-count-info__heading">{{ 'input_app_common.count' | translate }}</div>
          <div class="bulk-count-info__value">{{ count }}</div>
        </div>
      </ion-row>
      <ion-row class="buttons ion-justify-content-between">
        <div class="decrement" (click)="decrement()">
          <ion-img [src]="subtractIcon"></ion-img>
        </div>
        <div class="increment" (click)="increment()">
          <ion-img [src]="addIcon"></ion-img>
        </div>
      </ion-row>
    </div>
  </div>
</div>
